import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

export const get = defaultClient.query({
  url: 'datintell/v1/external_integrations/ghost/' as const,
  method: 'GET',
  responseSchema: z
    .object({
      id: z.number(),
      companyId: z.number(),
      provider: z.string(),
      status: z.string(),
      default: z.boolean(),
      type: z.string(),
      createdAt: z.string().nullable(),
      isManaged: z.boolean(),
      platform: z.string(),
      usedInMediaPlan: z.boolean(),
    })
    .array(),
});

export const integrateGhost = defaultClient.mutation({
  url: 'datintell/v1/external_integrations/ghost/' as const,
  method: 'POST',
  requestSchema: z.object({
    name: z.string(),
    type: z.string(),
    provider: z.string(),
  }),
  responseSchema: z.object({
    id: z.number(),
    companyId: z.number(),
    provider: z.string(),
    status: z.string(),
    default: z.boolean(),
    type: z.string(),
    createdAt: z.string().nullable(),
    isManaged: z.boolean(),
    platform: z.string(),
    usedInMediaPlan: z.boolean(),
  }),
  processResponse: (data) => {
    return data;
  },
});
